import { useEffect, useState } from 'react';

import { Daum } from '../../types/global';

/** @category useGetPostCode */
export type DaumPostCodeData = {
  /** 우편번호 */
  zonecode: string;
  /** 주소 */
  address: string;
};

/**
 * @description 다음 우편번호 조회 API를 사용하여 검색 화면 생성자를 반환하는 커스텀 훅
 * @link 가이드 문서 https://postcode.map.daum.net/guide
 * @example
 * // 1. 생성자 함수 반환
 * const { postCodeFinder } = useGetPostCode();
 * // 2. 생성자 함수로 검색 화면 생성
 * const iframe = new postCodeFinder.Postcode({ width, _, height: _, onComplete: (data) => ... });
 * // 3. 생성된 검색 화면을 targetElement에 삽입
 * iframe.embed(targetElement);
 */
export const useGetPostCode = () => {
  const [postCodeFinder, setPostCodeFinder] = useState<Daum | null>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    document.head.appendChild(script);
    script.onload = () => {
      setPostCodeFinder(window.daum);
    };
    return () => script.remove();
  }, []);

  return { postCodeFinder };
};

export default useGetPostCode;
